<div class="container-fluid pl-0 pr-0">
    <h6 class="cursor-default font-weight-light pl-4">{{ 'orgprojectmemberlist.title' | trans }}</h6>
    <p class="cursor-default pl-4">{{ 'orgprojectmemberlist.subtitle' | trans }}</p>
    <div class="card border-0">
        <div class="loading_overlay rounded" *ngIf="showSpinner">
            <app-loader></app-loader>
        </div>
        <div class="card-body border-0 p-0 bg-lightergrey">
            <div class="card p-0 no-border border-0 bg-lightergrey">
              <div *ngFor="let pers of members" class="row p-3 pl-4">
                <div class="col-4">
                  <a data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" (click)="onClick(pers)" 
                  matTooltip="{{ 'orgprojectmemberlist.showdetailsof' | trans }}{{ pers.membername }}" matTooltipPosition="above" matTooltipShowDelay="1000">
                    <h6 class="font-weight-light lh-35 align-middle cursor-pointer">{{ pers.fullname }}</h6></a>
                </div>
                <div (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" 
                  class="col-2 d-none d-sm-none d-md-block">
                  <p class="mb-0 cursor-pointer lh-35 align-middle">{{ 'orgprojectmemberlist.joined' | trans }}{{ pers.date_added | date:'yyyy-MM-dd' }}</p>
                </div>
                <div (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" 
                  class="col-2 d-none d-sm-none d-md-block">
                  <p class="mb-0 cursor-pointer lh-35 align-middle">{{ pers.phone }}</p>
                </div>
                <div (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" class="col-1">
                  <p class="mb-0 cursor-pointer lh-35 align-middle">{{ pers.city}}</p>
                </div>
                <div (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" class="col-2">
                  <p class="mv-0 cursor-pointer lh-35 align-middle">{{ pers.projectrole }}</p>
                </div>
                <div (click)="setDeleteMember(pers)" data-toggle="modal" [attr.data-target]="'#userremovalconfirm'+projectId" class="col-1">
                  <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn icon p-0 center cursor-pointer">
                    delete
                    </span>
                </div>
              </div>
                <!-- <table class="table">
                    <thead></thead>
                    <tbody *ngFor="let pers of members">
                        <tr (click)="onClick(pers)" class="tr-orgprojectmemberlist tr-no-side-border" >
                        <td (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" scope="col"><a  matTooltip="Show details of {{ pers.membername }}" matTooltipPosition="above" matTooltipShowDelay="1000">
                        <h6 class="table-data member-name cursor-pointer">{{ pers.fullname }}</h6></a></td>
                        <td (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" scope="col"><h6 class="table-data tsk-date cursor-pointer">Joined  {{ pers.date_added | date:'yyyy-MM-dd' }}</h6></td>
                        <td (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" scope="col"><h6 class="table-data tsk-date cursor-pointer">{{ pers.phone }}</h6></td>
                        <td (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#orgprojectmemberlistModal'+projectId" scope="col"><h6 class="table-data tsk-date cursor-pointer">{{ pers.city}}</h6></td>
                        <td matTooltip="Edit Role" matTooltipPosition="left" matTooltipShowDelay="200" (click)="onClick(pers)" data-toggle="modal" [attr.data-target]="'#modaleditrole'+projectId"  scope="col"><h6 class="tsk-date table-data cursor-pointer">{{ pers.projectrole }}</h6></td>
                        <td matTooltip="Remove User" matTooltipPosition="left" matTooltipShowDelay="200" (click)="setDeleteMember(pers)" data-toggle="modal" [attr.data-target]="'#userremovalconfirm'+projectId" scope="col"><span class="material-icons delete-icon cursor-pointer">
                            delete
                            </span></td>
                        </tr>
                    </tbody>
                </table> -->
                <div class="container">
                    <div id="orgprojectmemberlistModal{{projectId}}" class="modal fade" role="dialog">
                        <app-personmodal [showPending]="false" [modalpersonId]="modalPerson.personId" [modalorgId]="modalorgId"></app-personmodal>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</div>
  
  <!-- Modal USER ROLE EDIT -->
  <div class="modal fade" id="modaleditrole{{projectId}}" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgprojectmemberlist.edituserrole' | trans }}</h5>
          <button #rolemodalclose type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <input type="email" class="form-control" aria-describedby="userrolehelp" placeholder="{{ 'orgprojectmemberlist.enteruserroleplace' | trans }}" [(ngModel)]="modalPerson.projectrole">
                <small id="userrolehelp" class="form-text text-muted">{{ 'orgprojectmemberlist.enteruserrolehelp' | trans }}</small>
              </div>
        </div>
        <div class="modal-footer">
            <div class="col">
                <button type="button" class="btn-close float-left" data-dismiss="modal"><p class="btn-save-text">{{ 'orgprojectmemberlist.close' | trans }}</p></button>
            </div>
            <div class="col">
                <button (click)="saveRole()" type="button" class="btn-save float-right"><p class="btn-save-text">{{ 'orgprojectmemberlist.savechanges' | trans }}</p></button>
            </div>
        </div>
      </div>
    </div>
  </div>

    <!-- Modal USER REMOVEVAL CONFIRM -->
    <div id="userremovalconfirm{{projectId}}" class="modal fade" tabindex="-1" role="dialog" >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgprojectmemberlist.confirmuserremoveval' | trans }}</h5>
              <button #deletemodalclose type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span >&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <p class="font-weight-light text-center">{{ 'orgprojectmemberlist.confirmuserremovevalmsg' | trans }}</p>
                <p class="mt-2 text-center text-muted">{{ memberToDelete.fullname }}</p>
            </div>
            <div class="modal-footer">
                <div class="col">
                    <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'orgprojectmemberlist.cancel' | trans }}</p></button>
                </div>
                <div class="col">
                    <button (click)="deleteMember()" type="button" class="btn-save"><p class="btn-save-text">{{ 'orgprojectmemberlist.removeuser' | trans }}</p></button>
                </div>
            </div>
          </div>
        </div>
      </div>